import {
	GETKYCREPORTLIST_SUCCESS,
	GETKYCREPORTLIST_FAILED,
	RESET_GETKYCREPORTLIST,
	LOADING_GETKYCREPORTLIST,
	NETWORK_ERROR_GETKYCREPORTLIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_GETKYCREPORTLIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case GETKYCREPORTLIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case GETKYCREPORTLIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_GETKYCREPORTLIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_GETKYCREPORTLIST:
			return (state = initialState);
		default:
			return state;
	}
};
